import { Link } from "react-router-dom";

const stats = [
  { value: "12,800+", label: "收录影视作品" },
  { value: "2,600+", label: "专业影评推荐" },
  { value: "98%", label: "用户满意度" },
  { value: "每日更新", label: "资讯与评分" },
];

export default function SiteIntro() {
  return (
    <section className="w-full px-4 py-12 md:px-8 md:py-16">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">
            关于可可影视
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            专业的影视资讯与评分推荐平台
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
            可可影视聚焦最新电影与电视剧资讯，汇集丰富的<b className="font-semibold text-foreground-900">影视作品资料、评分与推荐指数</b>。
            我们以清晰的内容分层与可靠的评分参考，帮助每一位影视爱好者快速筛选作品、深入了解剧情与主创信息，
            让「看什么」这件事变得简单。
          </p>
          <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
            {[
              "每日更新影视资讯与热榜",
              "多维度筛选，快速定位作品",
              "剧情、主创、评分信息完整",
              "编辑精选主题合辑推荐",
            ].map((feature) => (
              <li key={feature} className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-checkbox-circle-fill text-base text-secondary-500"></i>
                {feature}
              </li>
            ))}
          </ul>
          <div className="mt-7 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="whitespace-nowrap rounded-md bg-primary-600 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-700"
            >
              了解可可影视
            </Link>
            <Link
              to="/tvseries"
              className="whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
            >
              发现热门剧集
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="rounded-lg border border-background-200/80 bg-background-100 p-6"
            >
              <p className="font-heading text-2xl font-bold text-primary-700 md:text-3xl">
                {stat.value}
              </p>
              <p className="mt-2 text-sm text-foreground-500">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}